import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiShield, FiEye } = FiIcons;

const Header = () => {
  return (
    <header className="bg-black/20 backdrop-blur-lg border-b border-purple-500/20">
      <div className="container mx-auto px-4 py-6">
        <motion.div
          className="flex items-center justify-between"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-purple-600 rounded-lg">
              <SafeIcon icon={FiShield} className="text-2xl text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white">OSINT Verifier</h1>
              <p className="text-purple-300 text-sm">Identity Verification Engine</p>
            </div>
          </div>
          <div className="flex items-center space-x-6 text-purple-300">
            <div className="flex items-center space-x-2">
              <SafeIcon icon={FiEye} className="text-lg" />
              <span className="text-sm">Real-time Analysis</span>
            </div>
            <div className="flex items-center space-x-2">
              <SafeIcon icon={FiSearch} className="text-lg" />
              <span className="text-sm">OSINT Powered</span>
            </div>
          </div>
        </motion.div>
      </div>
    </header>
  );
};

export default Header;